const CrossCircleFilled = () => (
  <svg focusable={false} viewBox='0 0 14 14'>
    <path
      fill='#4B286D'
      fillRule='evenodd'
      d='M6.293 7L4.646 8.646a.5.5 0 1 0 .708.708L7 7.707l1.646 1.647a.5.5 0 1 0 .708-.708L7.707 7l1.647-1.646a.5.5 0 1 0-.708-.708L7 6.293 5.354 4.646a.5.5 0 1 0-.708.708L6.293 7zM7 14A7 7 0 1 1 7 0a7 7 0 0 1 0 14z'
    />
  </svg>
);

export default CrossCircleFilled;
